/** True when the given window is not the top-level window, i.e. the page is shown inside an iframe. */
export const isEmbeddedInFrame = (win: Pick<Window, 'self' | 'top'> = window): boolean => win.self !== win.top;
